export enum ResponsableType
{
    Legal = 1,
    Tecnico = 2,
    Comercial = 3,
    Advisor = 4
}
